import React from 'react'
import { SpacerSliceProps } from './types'

const SpacerSlice: React.FC<SpacerSliceProps> = ({ slice }) => (
  <>
    {[...Array(slice.primary?.size || 1).keys()].map((_, index) => (
      <br key={index} />
    ))}
  </>
)

export default SpacerSlice
